import { apiRequest } from "../services/apiRequest"

/**
 * Sales contact requests submitted from the marketing site
 * (core.SalesContact). Gated by the `sales_requests` permission module.
 */
const buildQuery = ({
  search = "",
  furnitureType = "",
  dateFrom = "",
  dateTo = "",
} = {}) => {
  const queryParams = new URLSearchParams()

  if (search) queryParams.set("search", search)
  if (furnitureType) queryParams.set("furniture_type", furnitureType)
  if (dateFrom) queryParams.set("date_from", dateFrom)
  if (dateTo) queryParams.set("date_to", dateTo)

  return queryParams
}

export const SalesRequests = {
  getSalesRequests: async ({ page = 1, pageSize = 10, ...filters } = {}) => {
    const queryParams = buildQuery(filters)
    queryParams.set("page", page)
    if (pageSize) queryParams.set("page_size", pageSize)

    const url = `/api/admin/sales-requests/?${queryParams.toString()}`
    return await apiRequest("get", url, undefined, { skipCache: true })
  },

  /** DELETE /api/admin/sales-requests/<id>/ — removes a single request. */
  deleteSalesRequest: async (id) => {
    const requestId = String(id ?? "").trim()
    if (!requestId) throw new Error("Missing sales request id")
    return await apiRequest("delete", `/api/admin/sales-requests/${requestId}/`)
  },

  /**
   * POST /api/admin/sales-requests/<id>/move-to-merchant/ — hands the request
   * over to the merchant requests table as pending. The invite, the email and
   * the accept/reject decision all happen on the Merchants page from there.
   */
  moveToMerchant: async (id) => {
    const requestId = String(id ?? "").trim()
    if (!requestId) throw new Error("Missing sales request id")
    return await apiRequest(
      "post",
      `/api/admin/sales-requests/${requestId}/move-to-merchant/`
    )
  },

  /** CSV of every row matching the current filters (not just the page). */
  exportSalesRequests: async (filters = {}) => {
    const queryParams = buildQuery(filters)
    const queryString = queryParams.toString()
    const url = `/api/admin/sales-requests/export/${
      queryString ? `?${queryString}` : ""
    }`

    return await apiRequest("get", url, undefined, {
      responseType: "blob",
      skipCache: true,
    })
  },
}

export default SalesRequests
